import { schemaMonitorActions } from './schema-monitor.actions';

export const initialState = {
  configs: [],
  results: [],
  changes: [],
  dashboard: [],
  instances: [],
  schemas: [],
  groups: [],
  groupConfigs: [],
  isLoading: [],
  error: [],
  runResult: null,
};

export function schemaMonitorReducer(state = initialState, action) {
  let status;

  switch (action.type) {
    case schemaMonitorActions.LOAD_CONFIGS_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'configs'] };
    case schemaMonitorActions.LOAD_CONFIGS_SUCCESS:
      return { ...state, configs: action.payload.response || [], isLoading: state.isLoading.filter(i => i !== 'configs'), error: [] };
    case schemaMonitorActions.LOAD_CONFIGS_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'configs'), error: [...state.error, status] };

    case schemaMonitorActions.CREATE_CONFIG_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'createconfig'] };
    case schemaMonitorActions.CREATE_CONFIG_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'createconfig'), error: [] };
    case schemaMonitorActions.CREATE_CONFIG_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'createconfig'), error: [...state.error, status] };

    case schemaMonitorActions.UPDATE_CONFIG_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'updateconfig'] };
    case schemaMonitorActions.UPDATE_CONFIG_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'updateconfig'), error: [] };
    case schemaMonitorActions.UPDATE_CONFIG_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'updateconfig'), error: [...state.error, status] };

    case schemaMonitorActions.DELETE_CONFIG_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'deleteconfig'] };
    case schemaMonitorActions.DELETE_CONFIG_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'deleteconfig'), error: [] };
    case schemaMonitorActions.DELETE_CONFIG_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'deleteconfig'), error: [...state.error, status] };

    case schemaMonitorActions.DISABLE_CONFIG_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'disableconfig'] };
    case schemaMonitorActions.DISABLE_CONFIG_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'disableconfig'), error: [] };
    case schemaMonitorActions.DISABLE_CONFIG_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'disableconfig'), error: [...state.error, status] };

    case schemaMonitorActions.SOFT_DELETE_CONFIG_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'softdeleteconfig'] };
    case schemaMonitorActions.SOFT_DELETE_CONFIG_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'softdeleteconfig'), error: [] };
    case schemaMonitorActions.SOFT_DELETE_CONFIG_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'softdeleteconfig'), error: [...state.error, status] };

    case schemaMonitorActions.LOAD_RESULTS_REQUEST:
      return { ...state, results: [], isLoading: [...state.isLoading, 'results'] };
    case schemaMonitorActions.LOAD_RESULTS_SUCCESS:
      return { ...state, results: action.payload.response || [], isLoading: state.isLoading.filter(i => i !== 'results'), error: [] };
    case schemaMonitorActions.LOAD_RESULTS_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'results'), error: [...state.error, status] };

    case schemaMonitorActions.LOAD_CHANGES_REQUEST:
      return { ...state, changes: [], isLoading: [...state.isLoading, 'changes'] };
    case schemaMonitorActions.LOAD_CHANGES_SUCCESS:
      return { ...state, changes: action.payload.response || [], isLoading: state.isLoading.filter(i => i !== 'changes'), error: [] };
    case schemaMonitorActions.LOAD_CHANGES_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'changes'), error: [...state.error, status] };

    case schemaMonitorActions.RUN_NOW_REQUEST:
      return { ...state, runResult: null, isLoading: [...state.isLoading, 'runnow'] };
    case schemaMonitorActions.RUN_NOW_SUCCESS:
      return { ...state, runResult: action.payload.response, isLoading: state.isLoading.filter(i => i !== 'runnow'), error: [] };
    case schemaMonitorActions.RUN_NOW_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'runnow'), error: [...state.error, status] };

    case schemaMonitorActions.LOAD_DASHBOARD_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'dashboard'] };
    case schemaMonitorActions.LOAD_DASHBOARD_SUCCESS:
      return { ...state, dashboard: action.payload.response || [], isLoading: state.isLoading.filter(i => i !== 'dashboard'), error: [] };
    case schemaMonitorActions.LOAD_DASHBOARD_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'dashboard'), error: [...state.error, status] };

    case schemaMonitorActions.LOAD_INSTANCES_REQUEST:
      return { ...state, instances: [], isLoading: [...state.isLoading, 'instances'] };
    case schemaMonitorActions.LOAD_INSTANCES_SUCCESS:
      return { ...state, instances: action.payload.response || [], isLoading: state.isLoading.filter(i => i !== 'instances'), error: [] };
    case schemaMonitorActions.LOAD_INSTANCES_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'instances'), error: [...state.error, status] };

    case schemaMonitorActions.LOAD_SCHEMAS_REQUEST:
      return { ...state, schemas: [], isLoading: [...state.isLoading, 'schemas'] };
    case schemaMonitorActions.LOAD_SCHEMAS_SUCCESS:
      return { ...state, schemas: action.payload.response || [], isLoading: state.isLoading.filter(i => i !== 'schemas'), error: [] };
    case schemaMonitorActions.LOAD_SCHEMAS_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'schemas'), error: [...state.error, status] };

    case schemaMonitorActions.CLEAR_RESULTS:
      return { ...state, results: [], changes: [] };

    // ── Group Cases ─────────────────────────────────────────────────────────
    case schemaMonitorActions.LOAD_GROUPS_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'groups'] };
    case schemaMonitorActions.LOAD_GROUPS_SUCCESS:
      return { ...state, groups: action.payload.response || [], isLoading: state.isLoading.filter(i => i !== 'groups'), error: [] };
    case schemaMonitorActions.LOAD_GROUPS_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'groups'), error: [...state.error, status] };

    case schemaMonitorActions.CREATE_GROUP_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'creategroup'] };
    case schemaMonitorActions.CREATE_GROUP_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'creategroup'), error: [] };
    case schemaMonitorActions.CREATE_GROUP_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'creategroup'), error: [...state.error, status] };

    case schemaMonitorActions.UPDATE_GROUP_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'updategroup'] };
    case schemaMonitorActions.UPDATE_GROUP_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'updategroup'), error: [] };
    case schemaMonitorActions.UPDATE_GROUP_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'updategroup'), error: [...state.error, status] };

    case schemaMonitorActions.DELETE_GROUP_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'deletegroup'] };
    case schemaMonitorActions.DELETE_GROUP_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'deletegroup'), error: [] };
    case schemaMonitorActions.DELETE_GROUP_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'deletegroup'), error: [...state.error, status] };

    case schemaMonitorActions.LOAD_GROUP_CONFIGS_REQUEST:
      return { ...state, groupConfigs: [], isLoading: [...state.isLoading, 'groupconfigs'] };
    case schemaMonitorActions.LOAD_GROUP_CONFIGS_SUCCESS:
      return { ...state, groupConfigs: action.payload.response || [], isLoading: state.isLoading.filter(i => i !== 'groupconfigs'), error: [] };
    case schemaMonitorActions.LOAD_GROUP_CONFIGS_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'groupconfigs'), error: [...state.error, status] };

    case schemaMonitorActions.ASSIGN_CONFIGS_TO_GROUP_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'assignconfigs'] };
    case schemaMonitorActions.ASSIGN_CONFIGS_TO_GROUP_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'assignconfigs'), error: [] };
    case schemaMonitorActions.ASSIGN_CONFIGS_TO_GROUP_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'assignconfigs'), error: [...state.error, status] };

    case schemaMonitorActions.REMOVE_CONFIG_FROM_GROUP_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'removeconfig'] };
    case schemaMonitorActions.REMOVE_CONFIG_FROM_GROUP_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'removeconfig'), error: [] };
    case schemaMonitorActions.REMOVE_CONFIG_FROM_GROUP_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'removeconfig'), error: [...state.error, status] };

    case schemaMonitorActions.ACTIVATE_GROUP_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'activategroup'] };
    case schemaMonitorActions.ACTIVATE_GROUP_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'activategroup'), error: [] };
    case schemaMonitorActions.ACTIVATE_GROUP_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'activategroup'), error: [...state.error, status] };

    case schemaMonitorActions.DEACTIVATE_GROUP_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'deactivategroup'] };
    case schemaMonitorActions.DEACTIVATE_GROUP_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'deactivategroup'), error: [] };
    case schemaMonitorActions.DEACTIVATE_GROUP_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'deactivategroup'), error: [...state.error, status] };

    case schemaMonitorActions.DOWNLOAD_GROUP_REPORT_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'downloadreport'] };
    case schemaMonitorActions.DOWNLOAD_GROUP_REPORT_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'downloadreport'), error: [] };
    case schemaMonitorActions.DOWNLOAD_GROUP_REPORT_FAILURE:
      status = action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'downloadreport'), error: [...state.error, status] };

    case schemaMonitorActions.SM_WORKFLOW_ACTION_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'smworkflowaction'] };
    case schemaMonitorActions.SM_WORKFLOW_ACTION_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'smworkflowaction'), error: [] };
    case schemaMonitorActions.SM_WORKFLOW_ACTION_FAILURE:
      status = action.payload && action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'smworkflowaction'), error: [...state.error, status] };

    case schemaMonitorActions.SM_WORKFLOW_ROLLBACK_REQUEST:
      return { ...state, isLoading: [...state.isLoading, 'smworkflowrollback'] };
    case schemaMonitorActions.SM_WORKFLOW_ROLLBACK_SUCCESS:
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'smworkflowrollback'), error: [] };
    case schemaMonitorActions.SM_WORKFLOW_ROLLBACK_FAILURE:
      status = action.payload && action.payload.response ? action.payload.response.status : '500';
      return { ...state, isLoading: state.isLoading.filter(i => i !== 'smworkflowrollback'), error: [...state.error, status] };

    default:
      return state;
  }
}
